// The community's colors and, over them, a tour's theme on <html>. Every change recomputes the
// whole, so it doesn't matter which arrives first. Set as important because the server writes the
// community's colors into :root with !important.
let communityVars = {};
const worn = [];
let written = [];
// The color mode in place before anything was worn, given back when the last worn theme comes off.
let modeBeneath = null;
const applyVars = () => {
    const root = document.documentElement;
    const vars = Object.assign({}, communityVars, ...worn.map(theme => theme.vars));
    written.filter(name => !(name in vars)).forEach(name => root.style.removeProperty(name));
    Object.entries(vars).forEach(([name, value]) => root.style.setProperty(name, value, 'important'));
    written = Object.keys(vars);
};
const applyMode = () => {
    var _a, _b;
    const root = document.documentElement;
    const mode = (_b = (_a = [...worn].reverse().find(theme => theme.mode)) === null || _a === void 0 ? void 0 : _a.mode) !== null && _b !== void 0 ? _b : modeBeneath;
    if (mode === null)
        root.removeAttribute('data-bs-theme');
    else
        root.setAttribute('data-bs-theme', mode);
};
export const setCommunityTheme = (vars) => {
    communityVars = vars;
    applyVars();
};
// Puts a theme on over the community's, until the returned function takes it off.
export const wearTheme = (theme) => {
    if (worn.length === 0)
        modeBeneath = document.documentElement.getAttribute('data-bs-theme');
    worn.push(theme);
    applyVars();
    applyMode();
    return () => {
        const index = worn.indexOf(theme);
        if (index === -1)
            return;
        worn.splice(index, 1);
        applyVars();
        applyMode();
    };
};
